import { useCallback, useEffect, useRef, useState } from 'react';
import { AudioPlayer, IAudioPlayer } from '../../module/AudioPlayer';

interface UseAudioPlayerProps {
  signUrl?: string;
  containerRef: React.RefObject<HTMLDivElement>;
  onLoadingChange?: (loading: boolean) => void;
}

export const usePreviewPlayerCard = ({ signUrl, containerRef, onLoadingChange }: UseAudioPlayerProps) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const musicPlayerRef = useRef<IAudioPlayer | null>(null);

  useEffect(() => {
    if (!signUrl || !containerRef.current) return;

    musicPlayerRef.current = null;

    onLoadingChange?.(true);
    musicPlayerRef.current = new AudioPlayer(signUrl, containerRef.current);

    musicPlayerRef.current.setPlayPauseCallback(() => {
      setIsPlaying(musicPlayerRef.current?.isPlaying() || false);
    });

    musicPlayerRef.current.setAudioProcessCallback((time) => {
      setCurrentTime(time);
    });

    musicPlayerRef.current.setReadyCallback(() => {
      onLoadingChange?.(false);
    });

    setDuration(musicPlayerRef.current.getDuration());

    return () => {
      musicPlayerRef.current?.destroy();
    };
  }, [signUrl]);

  const onPlayPause = useCallback(() => {
    if (musicPlayerRef.current) {
      if (isPlaying) {
        musicPlayerRef.current.pause();
      } else {
        musicPlayerRef.current.play();
      }
    }
  }, [isPlaying]);

  return {
    isPlaying,
    currentTime,
    duration,
    onPlayPause,
  };
};
